module.exports = __webpack_public_path__ + "img/oran_7kl.43aa275b.jpg";